const SCRIPT_URL = 'https://sch.apiairasia.com/webui-libs/uhf/1.6.8/script.js';
const STYLE_URL = 'https://sch.apiairasia.com/webui-libs/uhf/1.6.8/style.css';
const FONT_URL = 'https://fonts.googleapis.com/icon?family=Material+Icons';

const SETTINGS = {
  linkMenuSection: false,
  languageSection: false,
  currencySection: false,
  loginSection: false,
  footerSection: true,
  isHeaderRequired: true,
};

const PRODUCTION_ENV = 'prod';
const STAGE_ENV = 'stg';

const DEFAULT_CURRENCY = 'MYR';
const DEFAULT_LANGUAGE = 'en-gb';

export const UHF = {
  SCRIPT_URL,
  STYLE_URL,
  FONT_URL,
  SETTINGS,
  DEFAULT_CURRENCY,
  DEFAULT_LANGUAGE,
  PRODUCTION_ENV,
  STAGE_ENV,
};
